import axios from 'axios';
import { REGION_API_URL } from './constants';

export const getVisitorLocation = async () => {
	const storageKeys = {
		locale: 'visitorLocale',
		region: 'visitorRegion',
	};
	const searchParams = new URLSearchParams(window.location.search);

	if (!sessionStorage.getItem(storageKeys.locale) || !sessionStorage.getItem(storageKeys.region) || searchParams.has('region')) {
		try {
			const response = await axios.get(REGION_API_URL);

			const locale = navigator.language.includes('-') ? navigator.language : `${navigator.language}-${response.data.country}`;
			const region = (searchParams.has('region') ? searchParams.get('region') : response.data.region).toLowerCase();

			sessionStorage.setItem(storageKeys.locale, locale);
			sessionStorage.setItem(storageKeys.region, region);

			return { locale, region };
		} catch (error) {
			console.error('Error fetching region and locale:', error);
		}
	} else {
		return {
			locale: sessionStorage.getItem(storageKeys.locale),
			region: searchParams.has('region') ? searchParams.get('region').toLowerCase() : sessionStorage.getItem(storageKeys.region),
		};
	}
};
